import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import Colors from '../../theming/Colors';
import Spacing from '../../theming/Spacing';
import KitText from '../KitText';

interface IKitInputValidationMessageProps {
  children: React.ReactNode;
  message: string | null;
  /**
   * @deprecated
   * Leave undefined to show the message when provided.
   * Message will automatically be hidden if the message is null or empty.
   * Set isNotValid to false to hide the message, even when the message is provided.
   */
  isNotValid?: boolean;
  bottom?: number;
  messageStyle?: StyleProp<ViewStyle>;
}

export default function KitInputValidationMessage({
  children,
  message,
  isNotValid,
  bottom = -40,
  messageStyle,
}: IKitInputValidationMessageProps): JSX.Element {
  const showMessage = message && isNotValid !== false;

  return (
    <View>
      {children}
      {showMessage && (
        <View style={[styles.container, { bottom }, messageStyle]}>
          <KitText color={Colors.N0} fontSize={18}>
            {message}
          </KitText>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: Colors.R500,
    paddingHorizontal: Spacing.m,
    paddingVertical: 7,
    borderRadius: Spacing.s,
  },
});
